import client from '@config/client'
import API_URL from '@config/services'
import { ApiClientResult } from '@/types/api'

interface OperationPayload {
  name?: string
  description?: string
  status?: string
  date_start?: string
  date_end?: string
  [key: string]: any
}

interface ProjectUserPayload {
  project: number | string
  user: number | string
  role?: string
  [key: string]: any
}

/**
 * Gets an operation by ID
 * @param operationId - Operation ID
 * @returns API response
 */
export const onGetOperation = (
  operationId: number | string
): Promise<ApiClientResult> => {
  return client
    .get(API_URL.PROJECTS.GET_PROJECT_PK(operationId))
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Gets operation details by ID
 * @param operationId - Operation ID
 * @returns Operation data
 */
export const getOperationDetails = (
  operationId: number | string
): Promise<any> => {
  return client
    .get(API_URL.PROJECTS.GET_PROJECT_PK(operationId))
    .then(response => response.data)
    .catch(error => {
      return error.response
    })
}

/**
 * Gets operation lease articles
 * @param operationId - Operation ID
 * @returns Array of lease articles
 */
export const onGetOperationLeaseArticles = (
  operationId: number | string
): Promise<any[]> => {
  return client
    .get(API_URL.PROJECTS.GET_PROJECT_LEASE_ARTICLES(operationId))
    .then(response => response?.data?.results || [])
    .catch(error => {
      return error.response
    })
}

/**
 * Updates an operation
 * @param operationId - Operation ID
 * @param payload - Operation data to update
 * @returns API response
 */
export const updateOperation = (
  operationId: number | string,
  payload: Partial<OperationPayload>
): Promise<ApiClientResult> => {
  return client
    .patch(API_URL.PROJECTS.GET_PROJECT_PK(operationId), payload)
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Adds a user to a project
 * @param payload - Project user data
 * @returns API response
 */
export const onPostProjectUser = (
  payload: ProjectUserPayload
): Promise<ApiClientResult> => {
  return client
    .post(API_URL.PROJECTS.POST_PROJECT_USERS, payload)
    .then(response => response)
    .catch(error => error.response)
}
